import React from 'react'
import { BgIcon, BgImage } from './components'

// don't create a player until you click a button
class LazyPreview extends React.Component {
    constructor (props) {
        super(props)
        this.state = {
            canPlay: false
        }
        this.click = this.click.bind(this)
    }

    click (ev) {
        ev.preventDefault()
        this.setState({ canPlay: true })
    }

    render () {
        var { asset } = this.props

        //   if thumbnail, play button is over thumb
        //   else play button is above a gray bg

        return <div className="inv-lazy-preview">
            {this.state.canPlay ?
                <Player asset={asset} /> :
                createThumbnail.call(this)
            }
        </div>
    }
}

function createThumbnail () {
    var { asset } = this.props
    var { thumbnail } = asset
    return <a href="#" onClick={this.click}>
        {thumbnail ?
            <BgImage src={thumbnail}>
                <button className="inv-main-button" onClick={this.click}>
                    <i className="far fa-circle-play" aria-hidden="true" />
                </button>
            </BgImage> :

            <BgIcon>
                <button className="inv-main-button" onClick={this.click}>
                    <i className="far fa-circle-play" aria-hidden="true" />
                </button>
            </BgIcon>
        }
    </a>
}

function getSourceURL (asset) {
    try {
        return asset.previewURI.main || asset.previewURI.backup
    } catch (err) {
        return asset.fileUrl
    }
}

var playerId = 0
class Player extends React.PureComponent {
    constructor (props) {
        super(props)
    }

    componentWillMount () {
        this._id = 'inv-player-' + playerId++
    }

    componentDidMount () {
        var { asset } = this.props
        var root = document.getElementById(this._id)
        var el = document.createElement('video')
        el.className = (el.className + ' video-js').trim()
        root.appendChild(el)

        var player = window.videojs(el, {
            // fluid: true,
            fill: true,
            controls: true,
            autoplay: true,
            // poster: false,
            preload: 'auto',
            // controlBar: false,
            bigPlayButton: false,
            controlBar: {
            //     playToggle: false,
            //     currentTimeDisplay: true,
            //     timeDivider: true,
            //     durationDisplay: true,
            //     remainingTimeDisplay: false,
            //     progressControl: false,
                volumePanel: {
                    inline: false
                }
            //     fullscreenToggle: false
            },
            sources: [
                { src: getSourceURL(asset) }
            ]
        })

        this._player = player
    }

    componentWillUnmount () {
        this._player.dispose()
    }

    render () {
        return <div className="inv-player" id={this._id} />
    }
}

export default LazyPreview
